import Api from "./Api";
import Csrf from "./Csrf";

export default { 
	
  async index() {
    await Csrf.getCookie();

    return Api.get("/apartment_prices");
  },	
	
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/apartment_prices/"+id);
  },	

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/apartment_prices/"+id);
  },	
	
  async store(data) {
    await Csrf.getCookie();

    return Api.post("/apartment_prices",data);
  },	
	
	
};